import { AbstractInlineEditor } from './abstract-inline-editor';
import {map, takeUntil} from 'rxjs/operators';

export class EldaDownloadInlineEditor extends AbstractInlineEditor {

    public onEdit(entity: any, event: any) {

    }

    public onBlur(entity: any, event: any) {

    }

    public onFocus(entity: any, event: any) {
        const a = document.createElement('a');
        document.body.appendChild(a);
        a.style.setProperty('display', 'none');

        return this.genericCrudService.directDownload('assets/exports/elda/' + entity.receivedFileName)
          .pipe(
            takeUntil(this.component.unsubscribe),
            map((data: any) => {
            const blob = new Blob([data],
            { type: 'text/plain' });
                const url = window.URL.createObjectURL(blob);

                a.href = url;
                a.download = entity.receivedFileName;
                a.click();
                window.URL.revokeObjectURL(url);
            }));
    }
}
